const OverflowingStyle = { textOverflow: 'ellipsis', whiteSpace: 'break-spaces' };

export default function servicesRequestedColumnSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((quote, index) => {
        let row = [];
        const rowId = quote.orderId;
        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let columnValue = null;
            let isDisabled = false;
            if (columnDataType === "string") {
                if (columnId === "additionalComments") {
                    columnValue = quote.additionalComments || "";
                }
                if (columnId === "servicesRequested") {
                    columnValue = (<>
                        {
                            quote?.countryMappingSelected?.specialLogistics &&
                            <div style={OverflowingStyle}>
                                {
                                    quote.countryMappingSelected.specialLogistics === 'Y' ?
                                        "Special Logistics Service" :
                                        "Standard Logistics Service"
                                }
                            </div>
                        }
                        {
                            quote?.countryMappingSelected?.onsiteProcessing &&
                            <div>
                                {
                                    quote.countryMappingSelected.onsiteProcessing === 'Y' ?
                                        "Onsite Data Sanitization" :
                                        "Offsite Data Sanitization"
                                }
                            </div>
                        }
                    </>);
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}